import { getHtmlRingbaPhoneNumberTemplate, getInnerRingbaPhoneNumberTemplate } from "../../shortcodes/templates";

let ringbaPhoneNumberShortcode = null;
const visualizeRingbaPhoneNumber = content => {
  ringbaPhoneNumberShortcode = content.querySelectorAll('[class="ringba-phone-number"]');
  if (ringbaPhoneNumberShortcode.length > 0) {
    ringbaPhoneNumberShortcode.forEach(item => {
      const ringbaPhoneNumberData = JSON.parse(item.getAttribute("data-ringba-phone-number"));

      item.innerHTML = getInnerRingbaPhoneNumberTemplate(ringbaPhoneNumberData);
    });
  }
};

const serializeRingbaPhoneNumber = content => {
  const ringbaPhoneNumberShortcode = content.querySelectorAll('[class="ringba-phone-number"]');
  if (ringbaPhoneNumberShortcode.length > 0) {
    ringbaPhoneNumberShortcode.forEach(item => {
      const ringbaPhoneNumberData = JSON.parse(item.getAttribute("data-ringba-phone-number"));
      item.innerHTML = getHtmlRingbaPhoneNumberTemplate(ringbaPhoneNumberData);
    });
  }
};

export { visualizeRingbaPhoneNumber, serializeRingbaPhoneNumber };
